<template>
  <div style="margin-bottom: 56px" class="hidden-sm-and-up">
    <div class="mobile_nav_wrap hidden-sm-and-up">
      <div class="navbar_left" @click="gobackHome">
        <div class="imgs">
          <img src="@/assets/logox.png" alt="氢能" />
        </div>
      </div>
      <div class="navbar_right">
        <div class="nav_btns" @click="moveMenu">
          <i class="el-icon-menu"></i>
        </div>
      </div>
    </div>
    <Affix>
      <div class="nav_menu" ref="menu">
        <router-link
          class="menu_item"
          to="/home"
          :class="currentActive === 0 ? 'active' : ''"
          >首页</router-link
        >
        <div
          class="menu_item"
          @click="changeMark"
          :class="currentActive === 4 ? 'active' : ''"
        >
          组建形式
        </div>
        <div class="item_options" v-show="markShow">
          <a href="/combination/1">公司联盟</a>
          <a href="/combination/2">研究院（牵头）</a>
        </div>
        <div
          class="menu_item"
          @click="changeProductShow"
          :class="currentActive === 1 ? 'active' : ''"
        >
          谋篇布局
        </div>
        <div class="item_options" v-show="productShow">
          <a href="/plan/1">研发攻关</a>
          <a href="/plan/2">中试检测</a>
          <a href="/plan/3">标准化体系</a>
          <a href="/plan/4">人才交流</a>
        </div>
        <div
          class="menu_item"
          @click="changeCenterShow"
          :class="currentActive === 2 ? 'active' : ''"
        >
          新闻动态
        </div>
        <div class="item_options" v-show="centerShow">
          <a href="/news/1" style="height: 25%">通知公告</a>
          <a href="/news/2" style="height: 25%">中心新闻</a>
          <a href="/news/3" style="height: 25%">行业资讯</a>
          <a href="/news/3" style="height: 25%">会议活动</a>
        </div>
        <div
          class="menu_item"
          @click="changeAchievementShow"
          :class="currentActive === 5 ? 'active' : ''"
        >
          创新成果
        </div>
        <div class="item_options" v-show="achievementShow">
          <a href="/achievement" style="height: 25%">成果转化</a>
          <a href="/expand" style="height: 25%">拓展合作</a>
          <a href="/knowledge/1" style="height: 25%">行业标准</a>
          <a href="/knowledge/2" style="height: 25%">企业专利</a>
          <a href="/knowledge/3" style="height: 25%">企业论文</a>
        </div>
        <div
          class="menu_item"
          @click="changeDataShow"
          :class="currentActive === 6 ? 'active' : ''"
        >
          大数据中心
        </div>
        <div class="item_options" v-show="dataShow">
          <!-- <a href="/news/1" style="height: 25%">可视化大屏</a> -->
          <a href="/green" style="height: 25%">绿色低碳</a>
        </div>
        <div
          class="menu_item"
          @click="changefireShow"
          :class="currentActive === 3 ? 'active' : ''"
        >
          了解公司
        </div>
        <div class="item_options" v-show="fireShow">
          <a href="/fivenav/1">公司介绍</a>
          <a href="/fivenav/2">联系公司</a>
          <a href="/fivenav/3">联系我们</a>
        </div>
      </div>
    </Affix>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menuShow: false,
      productShow: false,
      centerShow: false,
      fireShow: false,
      markShow: false,
      achievementShow: false,
      dataShow:false
    };
  },
  props: {
    currentActive: {
      default: 0,
      type: Number,
    },
  },
  methods: {
    moveMenu() {
      this.menuShow = !this.menuShow;
      if (this.menuShow) {
        this.$refs.menu.style.top = "56PX";
      } else {
        this.$refs.menu.style.top = "-1000PX";
      }
    },
    changeDataShow() {
      this.dataShow = !this.dataShow;
      this.fireShow = false;
      this.centerShow = false;
      this.productShow = false;
      this.markShow = false;
      this.achievementShow = false;
    },
    changeMark() {
      this.markShow = !this.markShow;
      this.centerShow = false;
      this.achievementShow = false;
      this.fireShow = false;
      this.productShow = false;
      this.dataShow = false;
    },
    changeProductShow() {
      this.productShow = !this.productShow;
      this.centerShow = false;
      this.achievementShow = false;
      this.fireShow = false;
      this.markShow = false;
      this.dataShow = false;
    },
    changeCenterShow() {
      this.centerShow = !this.centerShow;
      this.achievementShow = false;
      this.fireShow = false;
      this.productShow = false;
      this.markShow = false;
      this.dataShow = false;
    },
    changefireShow() {
      this.fireShow = !this.fireShow;
      this.centerShow = false;
      this.achievementShow = false;
      this.productShow = false;
      this.markShow = false;
      this.dataShow = false;
    },
    changeAchievementShow() {
      this.achievementShow = !this.achievementShow;
      this.fireShow = false;
      this.centerShow = false;
      this.productShow = false;
      this.markShow = false;
      this.dataShow = false;
    },
    gobackHome() {
      this.$router.replace("/home").catch((v) => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.mobile_nav_wrap {
  box-sizing: border-box;
  width: 100%;
  height: 56PX;
  background: #fff;
  z-index: 1000;
  display: flex;
  padding: 15px 0 15px 15px;
  align-items: center;
  position: fixed;
  top: 0;
  .navbar_left {
    flex: 1;
    background: #fff;
    height: 56PX;
    .imgs {
      width: 56PX;
      height: 100%;
      display: flex;
      align-items: center;
      img {
        width: 100% !important;
      }
    }
  }
   .navbar_right {
    flex: 2;
    height: 56PX;
    display: flex;
    justify-content: flex-end;
    background: #fff; 
    .nav_tiyan {
      width: 88PX;
      height: 100%;
      background: #1a63c4;
      color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14PX;
    }

    .nav_btns {
      width: 56PX;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      i{
        font-size: 30PX;
      }
    }
  }
}
.active{
  color: #F39C00 !important;
  font-weight: bold;
}
.nav_menu{
    position: absolute;
    width: 100%;
    height: 450PX;
    list-style: none;
    left: 0;
    right: 0;
    top: -1000PX;
    padding-bottom: 0;
    box-sizing: border-box;
    background: #EFF0F1;
    box-shadow: 0 10PX 20PX rgba(0,0,0,.1);
    z-index: 10;
    transition: all 0.8s;
    .menu_item{
      width: 100%;
      height: 40PX;
      font-size: 16PX;
      background: #EFF0F1;
      color: #1c212d;
      padding: 30PX;
      display: flex;
      align-items: center;
    }
    .item_options{
      width: 100%;
      padding: 5PX 10PX;
      // height: 150PX;
      font-size: 14PX;
      background: #fff;
      a{
        display: inline-block;
        width: 100%;
        color: #666;
        height: 25%;
        padding: 20px 30PX;
      }
    }
  }
</style>